<div class="breadcrumb flat">
  <a
    (click)="
      showWarningModal(
        '/' + this.getUrlPath + '/vendor/portal',
        'Attention',
        'En retournant à l\'accueil, vous perdrez votre configuration non sauvegardée <br> Voulez vous continuer ?',
        true
      )
    ">
    <fa-icon [icon]="faHome"></fa-icon>
  </a>

  <a
    [class.active]="currentPage === INSPIRATION"
    (click)="
      showWarningModal(
        '/' + this.getUrlPath + '/vendor/',
        'Attention',
        'En retournant sur cette page, vous devrez recommencer le processus. <br> Voulez vous continuer ?'
      )
    ">
    Inspiration
  </a>
  <a [routerLink]="['/', this.getUrlPath, 'vendor', 'configuration']" [class.active]="currentPage === CONCEPTION">
    Conception
  </a>
  @if (this.isCurrentContextKitchen || isCurrentContextWorkbench) {
    <a
      [class.active]="currentPage === PLAN_DE_TRAVAIL"
      [ngClass]="{
        'breadcrumb-disabled': (!isWorkbenchCreated() && !isOnWorkbench() && !isBomLoaded()) || workbenchLoading,
      }"
      (click)="goToWorkbench()">
      Plan de travail
    </a>
  }

  <!-- TODO On peut mieux faire ici -->
  @if (this.isCurrentContextKitchen || isCurrentContextWorkbench) {
    <a
      [routerLink]="['/', this.getUrlPath, 'vendor', 'recapitulatif']"
      [class.active]="currentPage === RECAPITULATIF"
      [ngClass]="{ 'breadcrumb-disabled': !isUnlocked || workbenchLoading }">
      Pose
    </a>
  }
  <a
    [routerLink]="['/', this.getUrlPath, 'vendor', 'financement']"
    [class.active]="currentPage === FINANCEMENT"
    [ngClass]="{ 'breadcrumb-disabled': !isUnlocked || workbenchLoading }">
    Financement
  </a>
  <a
    [class.active]="currentPage === VALIDATION"
    [ngClass]="{ 'breadcrumb-disabled': !isUnlocked || workbenchLoading }"
    (click)="
      showWarningModal(
        '/' + this.getUrlPath + '/vendor/validation',
        'Attention',
        'En accedant à la page de validation de cette manière, vos modifications ne seront pas pris en compte. <br> Voulez vous continuer ?'
      )
    ">
    Validation
  </a>
</div>
